import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'vennli_recent_paths';
const MAX_PATHS = 10;

export function getRecentPaths() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export default function useJourneyTracking() {
  const { pathname } = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (pathname === lastPathRef.current) return;
    lastPathRef.current = pathname;

    const paths = getRecentPaths();
    if (paths.length > 0 && paths[paths.length - 1].path === pathname) return;

    paths.push({ path: pathname, timestamp: new Date().toISOString() });
    if (paths.length > MAX_PATHS) {
      paths.splice(0, paths.length - MAX_PATHS);
    }

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(paths));
    } catch {
    }
  }, [pathname]);
}
